/**
 * نگه‌دارنده‌ی پیاده‌سازیِ پلتفرمِ فعلی — یک‌بار توسط اپ پر می‌شه، بقیه‌ی
 * core از پشتِ همین getterها می‌خونتش. نگاه کن به ports.ts برای قراردادها.
 *
 * چرا throw قبل از init: استفاده‌ی زودتر از موعد (باگِ ترتیبِ import) باید
 * همون لحظه با یه پیامِ خوانا بترکه، نه اینکه بی‌صدا AsyncStorage نال بده و
 * ساعت‌ها بعد به شکلِ «داده ذخیره نمیشه» خودش رو نشون بده.
 */
import type {
  CoreDeps, DiagFile, ImageCache, IpLocation, KeyValueStore, PlatformInfo,
} from './ports';

let deps: CoreDeps | null = null;

export function initCore(d: CoreDeps): void {
  deps = d;
}

function need<T>(v: T | undefined | null, name: string): T {
  if (v == null) {
    throw new Error(
      `core: ${name} پیش از initCore() استفاده شد — بوت‌استرپِ اپ initCore رو زودتر صدا بزنه.`,
    );
  }
  return v;
}

export const storage = (): KeyValueStore => need(deps, 'core').storage;
export const platformInfo = (): PlatformInfo => need(deps, 'core').platform;
export const imageCache = (): ImageCache | null => deps?.imageCache ?? null;
/** نبودش عادیه — نگاه کن به ports.ts، IpLocation. */
export const ipLocation = (): (() => Promise<IpLocation | null>) | null =>
  deps?.ipLocation ?? null;
/** نبودش عادیه — نگاه کن به ports.ts، DiagFile. */
export const diagFile = (): DiagFile | null => deps?.diagFile ?? null;
export const supabaseCreds = (): { url: string; anonKey: string } => {
  const d = need(deps, 'core');
  return { url: d.supabaseUrl, anonKey: d.supabaseAnonKey };
};
